import api from './api'

const basePath =  '/api/v1/customers'

const createDataError = (err, message) => ({error:{user:message, tech: err}})

export const getCustomer = async id => {
    const userMessage = `Falha ao consultar o cliente ID ${id} Tente Novamente!`
    let data = {}

    try {
        const response = await api.get(`${basePath}/${id}/`)
        if (response.status === 200){
            data = response.data
        } else {
            throw new Error(`Resposta do servidor ${response.status}`)
        }
    } catch (error) {
        data = createDataError(error, userMessage)
    } finally {
        return data
    }
}

export const getCustomers =  async (params={}, page=1, limit=10) => {
    const userMessage = `Não foi possivel encontrar o cliente`
    let data = []
    let response = null
    try {
        if (params.name){
            response = await api.get(`${basePath}/?name=${params.name}`)
        } else {
            response = await api.get(basePath)
        }
        if (response.status === 200){
            data = response.data
        } else {
            throw new Error(`Resposta do servidor ${response.status}`)
        }
    } catch (error) {
        data = createDataError(error, userMessage)
    } finally {
        return data
    }
}